var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8353 4.14118C18.3764 5.68229 18.3764 8.18093 16.8353 9.72204C15.2942 11.2631 12.7956 11.2631 11.2545 9.72204C9.71336 8.18093 9.71336 5.68229 11.2545 4.14118C12.7956 2.60007 15.2942 2.60007 16.8353 4.14118Z",
    stroke: "#40DA9E",
    strokeWidth: 5.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9722 15.183C17.5043 14.5965 15.782 14.2733 14.0417 14.2733C9.46708 14.2733 5.00098 16.4962 5.00098 19.9147V21.0448C5.00098 21.6686 5.50726 22.1749 6.13106 22.1749H16.7686",
    stroke: "#40DA9E",
    strokeWidth: 5.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9493 25.5948C18.8291 25.5948 16.2988 23.0657 16.2988 19.9444C16.2988 16.8886 18.898 14.2906 21.9538 14.2939C25.0728 14.2962 27.5997 16.8253 27.5997 19.9444C27.5997 23.0646 25.0706 25.5948 21.9493 25.5948Z",
    fill: "#40DA9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9493 25.5948C18.8291 25.5948 16.2988 23.0657 16.2988 19.9444C16.2988 16.8886 18.898 14.2906 21.9538 14.2939C25.0728 14.2962 27.5997 16.8253 27.5997 19.9444C27.5997 23.0646 25.0706 25.5948 21.9493 25.5948",
    stroke: "#40DA9E",
    strokeWidth: 3.84229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4664 18.6816L21.3271 21.821L19.4443 19.9372",
    stroke: "#F4F4F4",
    strokeWidth: 3.84229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.4e6be70a23f9ffdd631a0283f33f21d9.svg";
export { ForwardRef as ReactComponent };